import React from "react"

import '../styles/pages/ContactMe.css'

import Menu from "../components/Menu";
import Footer from "../components/Footer";
import ContactInfos from "../components/ContactInfos";
import ContactForm from "../components/ContactForm";


const ContactMe = () => {

    return (
        <>
            <header className='contact-header'>
                <Menu/>
            </header>
            <ContactInfos/>
            <ContactForm/>
            <Footer/>
        </>
    );
}

export default ContactMe;